// startup
// Load entry module and return exports
__webpack_require__("./assets/js/scripts.js");
// This entry module is referenced by other modules so it can't be inlined
__webpack_require__("./assets/js/vendors/bootstrap.js");
var __webpack_exports__ = __webpack_require__("./assets/scss/styles.scss");
